<div class="booking-summary">
  @if(booking && booking.Id && confirmed) {
  <div class="row">
    <div class="col-lg p-0 p-lg-3">
      <app-card>
        @if(booking.Status == rentalStatus.Canceled) {
        <div class="row">
          <div class="col-4 booking-confirmation-icon">
            <mat-icon color="warn">close</mat-icon>
          </div>
          <div class="col-8">
            <p>{{ 'Turbo_Core_bookingTooltip_Status_' + booking.Status | translate }}</p>
            <p>Bokningen är avbokad</p>
          </div>
        </div>
        }
        @if(booking.Status == rentalStatus.Reserved) {
        <div class="row">
          <div class="col-4 booking-confirmation-icon">
            <mat-icon class="success">done</mat-icon>
          </div>
          <div class="col-8">
            <strong>{{ 'Turbo_Core_bookingTooltip_Status_' + 50 | translate }}</strong>
            <p>{{ 'Intellitrailer.Booking.Components.BookingSummary.BookingCreated' | translate : 'Your booking has been created'}}</p>
          </div>
        </div>
        }
      </app-card>
    </div>
    @if(booking.Status == rentalStatus.Reserved) {
    <div class="col-lg p-0 p-lg-3">
      <app-invite-friend-screen isCustomerContext="false" showInvite="true" expandWidth="true"></app-invite-friend-screen>
    </div>
    }
  </div>
  }
  <div class="row">
    <app-card class="col-lg">
      <div class="row"><title-with-divider>{{ booking.PrimaryType?.Alias }}</title-with-divider></div>
      <img src="{{ typeImage }}" />
      @if(specificObject && !(booking && booking.Id && confirmed)) {
      <p>{{ specificObject.Type?.TypeClassId == 5 ? (specificObject.Alias ?? specificObject.Title) : (specificObject.Alias ? specificObject.Title + ' - ' + specificObject.Alias : specificObject.Title) }}</p>
      <div class="row mb-3"><a class="link" (click)="chooseSpecificTrailer()">{{ 'Intellitrailer.Booking.UnConfirmedBooking.ChooseSpecificTrailer' | translate : 'Choose specific trailer' }}</a></div>
      }

      @if(booking.PrimaryType.Attributes)
      {
      <div class="row">
        <div *ngFor="let attr of booking.PrimaryType.Attributes; let i = index"
             class="mb-3"
             [ngClass]="{'col-4' : booking.PrimaryType.Attributes.length % 3  == 0 || i < (booking.PrimaryType.Attributes.length - (booking.PrimaryType.Attributes.length % 3 || 3)),'col-12': booking.PrimaryType.Attributes.length % 3 == 1 && i == booking.PrimaryType.Attributes.length - 1,'col-6': booking.PrimaryType.Attributes.length % 3 == 2 && i >= booking.PrimaryType.Attributes.length - 2}">
          <div class="text-center">
            <h6>{{attr.Name | translate }}</h6>
            <small>{{attr.Value | transliterate}}{{attr.Unit | translate}}</small>
          </div>
        </div>
      </div>
      }
      <div class="row">
        <title-with-divider>{{ 'Intellitrailer.Booking.Components.BookingSummary.RentalPerioud' | translate : 'Rental period'}}</title-with-divider>
        <div class="col-5">
          <h6>{{ 'turbo.core.RentalDialog.Pickup' | translate : 'Pickup'}}</h6>
          <small>{{ booking.PickupTime | date : 'd MMM' }} - {{ booking.PickupTime | date : 'HH:mm' | transliterate }}</small>
        </div>
        <div class="col-2 bs-col-arrow">
          <mat-icon class="rtl-rotate">arrow_right_alt</mat-icon>
        </div>
        <div class="col-5">
          <h6>{{ 'turbo.core.RentalDialog.Return' | translate : 'Return'}}</h6>
          <small>{{ booking.ReturnTime | date : 'd MMM' }} - {{ booking.ReturnTime | date : 'HH:mm' | transliterate }}</small>
        </div>
      </div>
      <div class="row">
        <title-with-divider>{{ 'Intellitrailer.Booking.Components.BookingSummary.RentalLocation' | translate : 'Rental location'}}</title-with-divider>
        @if(booking.ReturnLocation && booking.ReturnLocation.Id != booking.PickupLocation.Id) {
        <div class="col-5">
          <p>{{ booking.PickupLocation.Name }}</p>
          <p>{{ booking.PickupLocation.Address }}</p>
        </div>
        <div class="col-2">
          <mat-icon class="bs-col-arrow rtl-rotate">arrow_right_alt</mat-icon>
        </div>
        <div class="col-5">
          <p>{{ booking.ReturnLocation.Name }}</p>
          <p>{{ booking.ReturnLocation.Address }}</p>
        </div>
        }
        @else {
        <small>{{ booking.PickupLocation.Name }}</small>
        <small>{{ booking.PickupLocation.Address }}</small>
        }
      </div>
    </app-card>
    <div class="d-lg-show"></div>
    <app-card class="col-lg">
      @if(shownAddons && shownAddons.length > 0) {
      <div class="row">
        <title-with-divider>{{ 'Intellitrailer.Booking.UnConfirmedBooking.Addons' | translate : 'Addons' }}</title-with-divider>
        <div *ngFor="let i of addons; let k = index">
          @if (!i.IsHidden && i.Title.indexOf('Depositum') == -1) {
          <div [ngClass]="!i.IsSelected && booking?.Id ? 'line-through' : 'line-not-through'">
            <!-- Custom Insurance for U4F and 24 Rental-->
            @if(i.Id == 1004 || i.Id == 901) {
            <div class="row">
              <div class="col-8 text-start">
                @if(i.Title.indexOf('Turbo.') == -1 && i.IsSelected) { <p>{{ i.Title }}</p> }
                @if(i.Title.indexOf('Turbo.') == 0 && i.IsSelected) { <p>{{ i.Title | translate }}</p> }
                @if(!i.IsSelected) { <mat-error class="line-not-through">{{ 'Intellitrailer.Booking.BookingSummary.msgChosenWithoutInsurance' | translate : 'You have chosen to drive without insurance.' }}</mat-error> }
                @if(i.Price && i.IsSelected) { <a (click)="addedProductChanged(i, false)">{{ 'Intellitrailer.Booking.UnConfirmedBooking.addonReadMore' | translate : 'Read more' }}</a> }
              </div>
              <div class="col-4">
                @if(!i.IsSelected) {
                <mat-checkbox [checked]="i.IsSelected" (change)="addedProductChanged(i, $event)" [disabled]="confirmed">
                  <p>
                    {{ i.Price | currency | transliterate }} /
                    @if(i.Period == 24!) { {{ 'Intellitrailer.Booking.BookingSummary.Day' | translate : 'day' }} }
                    @if(i.Period != 24) { {{ i.Period }}h  }
                  </p>
                </mat-checkbox>
                }
                @else if(i.Price) {
                <p>
                  {{ i.Price | currency | transliterate }} /
                  @if(i.Period == 24!) { {{ 'Intellitrailer.Booking.BookingSummary.Day' | translate : 'day' }} }
                  @if(i.Period != 24) { {{ i.Period }}h  }
                </p>
                }
              </div>
            </div>
            }
            @else {
            <div class="row">
              <div class="col-8">
                @if(i.Title.indexOf('Turbo.') == -1) { <p>{{ i.Title }}</p> }
                @if(i.Title.indexOf('Turbo.') == 0) { <p>{{ i.Title | translate }}</p> }
                @if(i.Price && i.IsSelected) { <a (click)="addedProductChanged(i, false)">{{ 'Intellitrailer.Booking.UnConfirmedBooking.addonReadMore' | translate : 'Read more' }}</a> }
              </div>
              <div class="col-4">
                @if(i.Price) {
                @if(i.IsSelected) {
                <p>
                  {{ i.Price | currency | transliterate }} /
                  @if(i.Period == 24!) { {{ 'Intellitrailer.Booking.BookingSummary.Day' | translate : 'day' }} }
                  @if(i.Period != 24) { {{ i.Period }}h  }
                </p>
                }
                @else {
                <mat-checkbox [checked]="i.IsSelected" (change)="addedProductChanged(i, $event)" [disabled]="confirmed">
                  <p>
                    {{ i.Price | currency | transliterate }} /
                    @if(i.Period == 24!) { {{ 'Intellitrailer.Booking.BookingSummary.Day' | translate : 'day' }} }
                    @if(i.Period != 24) { {{ i.Period }}h  }
                  </p>
                </mat-checkbox>
                }
                }
                @else {
                <p>{{ 'Intellitrailer.Booking.BookingSummary.Included' | translate : 'Included' }} </p>
                }
              </div>
            </div>
            }
            <div class="row" [ngClass]="!showAddonInfo[k] ? 'addon-info-hidden' : 'addon-info-show'">
              @if(i.Description && i.Description.indexOf('Turbo.') == 0) { <p>{{ i.Description | translate }}</p> }
              @else {  <p>{{ i.Description }}</p> }
            </div>
          </div>
          }

        </div>
      </div>
      }

      <div class="row">
        <title-with-divider>{{ 'Intellitrailer.Booking.Component.BookingSummary.CalculatedPriceHeader' | translate : 'Calculated price/ Addons' }}</title-with-divider>
        @if(currentPrice.RentalPrice <= 0) {
        <div class="row">
          <p class="col-9">{{ 'Intellitrailer.Booking.UnConfirmedBooking.FreeRent' | translate : 'Free rental period' }}</p>
          <p class="col-3"> {{ currentPrice.RentalPrice | currency | transliterate }}</p>
        </div>
        }

        @if(currentPrice.RentalPrice > 0) {
        <div class="row">
          <p class="col-9" [innerHTML]="rentalPeriodText"></p>
          <p class="col-3"> {{ currentPrice.RentalPrice | currency | transliterate }}</p>
        </div>
        }

        @if(currentPrice.Discount) {
        <div class="row">
          <p class="col-9" innerHTML="{{ 'turbo.core.RentalDialog.Discount' | translate : 'Discount'}}"></p>
          <p class="col-3"> {{ currentPrice.Discount | currency | transliterate }}</p>
        </div>
        }

        <!--<ng-container *ngFor="let i of removedProducts; let k = index">
          <div class="row line-through">
            <p *ngIf="i.Title.indexOf('Turbo.') == 0" class="col-9">{{ i.Title | translate }}</p>
            <p *ngIf="i.Title.indexOf('Turbo.') != 0" class="col-9">{{ i.Title }}</p>
            <p class="col-3 text-right">{{ i.Price | currency }} </p>
          </div>
        </ng-container>-->
        <div class="row" *ngFor="let i of currentPrice.AddedProducts; let k = index">
          @if(!i.Hidden) {
          @if(i.Name.indexOf('Turbo.') == 0) { <p class="col-9">{{ i.Name | translate }}</p> }
          @else {  <p class="col-9">{{ i.Name }}</p> }
          <p class="col-3">{{ i.OriginalPrice | currency | transliterate }} </p>
          }
        </div>

        @if(currentPrice.BookingFee) {
        <div class="row">
          <p class="col-9">
            {{ 'Intellitrailer.Booking.UnConfirmedBooking.BookingFee' | translate : 'BookingFee' }}
            <mat-icon class="toggle-addon-info-icon" (click)="showInfo('bookingFee')"> info </mat-icon>
          </p>
          <p class="col-3 text-right"> {{ currentPrice.BookingFee | currency | transliterate }}</p>
        </div>
        }
        <hr />
        <div class="row">
          <p class="col-9">
            <strong>
              {{ 'Intellitrailer.Booking.UnConfirmedBooking.Total' | translate : 'Total' }}
            </strong>
          </p>
          <p class="col-3 text-right">
            <strong>
              {{ currentPrice.DiscountedTotalPrice | currency | transliterate }}
            </strong>
          </p>
        </div>

        <div *ngFor="let i of currentPrice.AddedProducts; let k = index">
          @if(i.ExcludeFromSum && i.Price != 0) {
          <div class="row">
            @if(i.Name.indexOf('Turbo.') == 0) {
            <p class="col-9">
              {{ i.Name | translate }}
              <mat-icon class="toggle-addon-info-icon" (click)="showInfo('info', i.Name, addedPriceProds[k].Description)">info</mat-icon>
            </p>
            }
            @else {
            <p class="col-9 ">
              {{ i.Name }}
              <mat-icon class="toggle-addon-info-icon" (click)="showInfo('info', i.Name, addedPriceProds[k].Description)">info</mat-icon>
            </p>
            }
            <p class="col-3"> {{ i.Price | currency | transliterate }} </p>
          </div>
          @if(i.Name.indexOf('Deposit') > -1) {
          <p>
            {{ 'Intellitrailer.Booking.Component.BookingSummary.DepositInfo' | translate : 'The deposit is refundable after the rent is completed.' }}
          </p>
          }
          }
        </div>

        @if(showNoInsuranceMsg) {
        <title-with-divider>{{ 'Intellitrailer.Booking.UnConfirmedBooking.Information' | translate : 'Information' }}</title-with-divider>
        <mat-error>{{ 'Intellitrailer.Booking.BookingSummary.msgOptedOutOfInsurance' | translate : 'Please note that you have opted out of the insurance and in the event of damage there will be a deductible of 5000 SEK.' }}</mat-error>
        }

        @if(!showDiscount && !confirmed) {
        <div class="terms-link-wrapper">
          <a (click)="showDiscountCard()" [routerLink]="">{{ 'Intellitrailer.Booking.Component.BookingSummary.IHaveADiscountOrReferral' | translate : 'I have a discount/ referral code' }}</a>
        </div>
        }

        @if(showDiscount && !confirmed) {
        <title-with-divider>{{ 'Intellitrailer.Booking.Component.BookingSummary.ReferralOrDiscount' | translate : 'Discount/ referral'}}</title-with-divider>
        @if(!booking.DiscountId || booking.DiscountId.length == 0) {
        <div class="discount-input-wrapper">
          <mat-form-field appearance="outline" class="discount-input">
            <mat-label>{{ 'Intellitrailer.Booking.Component.BookingSummary.ReferralOrDiscountCode' | translate : 'Discount/ referral code'}}</mat-label>
            <input autocomplete="off" matInput [(ngModel)]="discountCode" [formControl]="discountControl">



            @if(discountLoading){
            <mat-progress-spinner matSuffix class="btn-spinner" mode="indeterminate" [diameter]="32" [strokeWidth]="3"></mat-progress-spinner>
            }
            @else{
            <button class="add-button" mat-mini-fab matSuffix (click)="addDiscount()">
              <mat-icon class="rtl-rotate">arrow_forward</mat-icon>
            </button>
            }

            <mat-error *ngIf="discountControl.hasError('incorrect')">
              {{ 'Intellitrailer.Booking.Component.BookingSummary.InvalidReferralOrDiscount' | translate : 'Invalid discount/ referral code' }}
            </mat-error>
          </mat-form-field>
        </div>
        }
        @if(booking.DiscountId && booking.DiscountId.length > 0) {
        <div class="row discount-info">
          <div class="col-9">
            <p>{{ 'Intellitrailer.Booking.Component.BookingSummary.lblCode' | translate : 'Code'}}: {{ booking.DiscountId }}</p>
            @if(discount && discount.Type == 0 && discount.Value > 0) { <p>{{ 'Intellitrailer.Booking.Component.BookingSummary.ReferralOrDiscount' | translate : 'Discount/ referral'}}: {{ discount.Value | transliterate }}%</p> }
            @if(discount && discount.Type == 1 && discount.Value > 0) { <p>{{ 'Intellitrailer.Booking.Component.BookingSummary.ReferralOrDiscount' | translate : 'Discount/ referral'}}: {{ discount.Value | currency | transliterate }}</p> }
            @if(discount && discount.Comment) { <p>{{ 'Intellitrailer.Booking.Component.BookingSummary.Comment' | translate : 'Comment'}}: {{ trimmedComment }}</p> }
          </div>
          <div class="col-3 remove-button-container">
            <button class="remove-button" mat-mini-fab matSuffix (click)="removeDiscount()">
              <mat-icon class="rtl-rotate">close</mat-icon>
            </button>
          </div>
        </div>
        }
        }
      </div>
    </app-card>
  </div>

  @if(!confirmed) {
  <div class="row">
    <app-card>
      <div class="row"><title-with-divider>{{ 'Intellitrailer.Booking.Component.BookingSummary.Terms' | translate : 'Terms and conditions' }}</title-with-divider></div>
      <!--<p id="continue-to-agree">{{ 'Intellitrailer.Booking.Component.BookingSummary.TermsIAccept' | translate : 'By continuing I hereby accept the terms and conditions' }}</p>-->
      <mat-checkbox [checked]="terms" (change)="termsToggle($event)"> <p id="continue-to-agree">{{ 'Intellitrailer.Booking.Component.BookingSummary.TermsReadAndAgreed' | translate : 'I read and agreed to terms and conditons' }}</p></mat-checkbox>
      @if(rentalAgreement) {
      <div class="terms-link-wrapper">
        <a (click)="showTerms()" [routerLink]="">{{ 'Intellitrailer.Rental.BookingSummary.ShowTerms' | translate : 'Show terms and conditions' }}</a>
        <mat-icon class="rtl-rotate">chevron_right</mat-icon>
      </div>
      }
      @if(extraConditionExist) {
      <mat-checkbox [checked]="specialConditionChecked" (change)="sendSpecialConditionToParent($event)"> {{ 'Intellitrailer.Rental.BookingSummary.SpecialCondition_' + booking.PrimaryObjectTypeId | translate : '[Additional Condition]' }}</mat-checkbox>
      }
    </app-card>
  </div>
  }
</div>

  @if(confirmed && offerCreated){
  <animated-campaign-card [booking]="booking">
  </animated-campaign-card>
  }
